export default "__VITE_ASSET__ClPsF4Wr__"